export default "__VITE_ASSET__C7x16oG6__"